import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import tr from './locales/tr.json'

export const supportedLanguages = [
  { code: 'en', label: 'English' },
  { code: 'tr', label: 'Türkçe' },
] as const

export type SupportedLang = typeof supportedLanguages[number]['code']

const supportedCodes = supportedLanguages.map((l) => l.code)

/** Detect the best matching language from browser preferences */
function detectBrowserLanguage(): SupportedLang {
  const langs = navigator.languages || (navigator.language ? [navigator.language] : [])
  for (const browserLang of langs) {
    const exact = browserLang.toLowerCase()
    if (supportedCodes.includes(exact as SupportedLang)) return exact as SupportedLang
    const base = exact.split('-')[0]
    if (supportedCodes.includes(base as SupportedLang)) return base as SupportedLang
  }
  return 'en'
}

function resolveLanguage(): SupportedLang {
  const stored = localStorage.getItem('oaas-lang')
  if (stored && supportedCodes.includes(stored as SupportedLang)) return stored as SupportedLang
  return detectBrowserLanguage()
}

/** Apply lang attribute to the document (all supported locales are LTR) */
export function applyDocumentDirection(lang: string) {
  document.documentElement.dir = 'ltr'
  document.documentElement.lang = lang
}

const initialLang = resolveLanguage()

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    tr: { translation: tr },
  },
  lng: initialLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

// Apply initial direction
applyDocumentDirection(initialLang)

// Update direction whenever language changes
i18n.on('languageChanged', (lang) => {
  applyDocumentDirection(lang)
  localStorage.setItem('oaas-lang', lang)
})

export default i18n
